/** Callback registered by the app so axios interceptors (outside React) can show the refresh-timeout overlay. */
let refreshTimeoutListener: (() => void) | null = null

export function registerRefreshTimeoutCallback(
  callback: (() => void) | null,
): void {
  refreshTimeoutListener = callback
}

export function showRefreshTimeout(): void {
  refreshTimeoutListener?.()
}
